export const STORYBLOK_FEATURE_NAME = 'storyblok';
